/** @jsxImportSource @emotion/react */
import { Box, Button, Typography } from "@mui/material";
import { logout } from "../../util/authentication";

const LogOutButton = (props) => {

  const handleLogInAgainClicked = async () => {
    await logout();
    window.location.reload();
  };

  return (
    <Box m={1}>
      <Button
        className="button"
        variant="contained"
        color="primary"
        size="large"
        fullWidth={true}
        href="#/logout"
        onClick={handleLogInAgainClicked}
      >
        <Typography variant="h5" component="h2">
          <Box className="screen-message-text">Log Out</Box>
        </Typography>
      </Button>
    </Box>
  );
};

export default LogOutButton;
